import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const challengesLongTextViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map